export default __webpack_public_path__ + "static/media/whitelogo.6ccbfe62.svg";